import React from "react";
import { Table, Container, Input, Button, Form, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { serverUrls, makeUrl, clientUrls } from "../Utils/Urls";
import {
  getPatients,
  getPatientsFailure,
  getPatientsSuccess,
} from "../Actions/patientAction";
import axios from "axios";
import Pagination from "react-js-pagination";

class ViewPatient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      totalPages: 1,
    };
    this.onChange = this.onChange.bind(this);
    this.getPatientsList = this.getPatientsList.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange = (number) => {
    this.setState({
      page: number,
    });
    this.getPatientsList(false, number);
  };

  componentDidMount() {
    this.getPatientsList();
    this.updatePageCount();
  }
  // componentWillUnmount() {
  //   this.props.resetPatientState();
  // }

  deletePatient(id) {
    var url = serverUrls.patient + id + "/";
    axios
      .delete(url)
      .then(() => {
        this.getPatientsList();
      })
      .catch(() => {});
  }

  updatePageCount = () => {
    var url = serverUrls.pageCount + "?search=" + this.state.search;
    axios
      .get(url)
      .then((res) => {
        this.setState({
          totalPages: res.data.count,
        });
      })
      .catch(() => {});
  };

  getPatientsList = (callUpdatePageCount = true, pageNo = this.state.page) => {
    if (callUpdatePageCount) this.updatePageCount();
    this.props.loadPatients(this.state.search, pageNo);
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    var tableValues = [];
    const getDisorderValue = (disordernum) => {
      const options = {
        0: "None",
        1: "Sclerotic bone diasease/ Non sclerotic bone disease",
        2: "Osteogenesis Imperfecta",
        3: "Fibrous dysplasia",
        4: "Pagets disease",
        5: "Tumor induced osteomalacia",
        6: "Pyknodysostosis",
        7: "CED",
        8: "Scleroteosis",
        9: "Juvenile osteoporosis",
        10: "Syndromic Diagnosis",
        11: "Atypical Femoral Fracture",
        12: "Osteoprosis",
        13: "T2D with Osteoporosis",
        14: "Any Other",
      };

      return options[disordernum] || "Undefined";
    };
    const getdisorders = (combinedString) => {
      const disorderDifferentiator = "🡸Disorder||Treatment🡺";
      return combinedString.includes(disorderDifferentiator)
        ? combinedString.substring(
            combinedString.indexOf(disorderDifferentiator) +
              disorderDifferentiator.length
          )
        : "";
    };

    this.props.patients.forEach((element, index) => {
      const renderDisorderOrTreatment = () => {
        const { disorders_and_treatments } = element;

        if (disorders_and_treatments && disorders_and_treatments[0]) {
          const { disorder, treatment } = disorders_and_treatments[0];

          if (typeof disorder !== "undefined" && parseInt(disorder) <= 13) {
            return getDisorderValue(parseInt(disorder));
          } else if (treatment) {
            return getdisorders(treatment);
          }
        }

        return "Undefined";
      };
      tableValues.push(
        <tr key={index}>
          <th scope="row">{index + 1 + (this.state.page - 1) * 10}</th>
          <th>{element.name}</th>
          <th>{element.sex}</th>
          <th>{element.crno}</th>
          <th>{renderDisorderOrTreatment()}</th>
          <th>{element.ecno}</th>
          <th>{new Date(element.DOA).toISOString().split("T")[0]}</th>
          <th>{new Date(element.DOS).toISOString().split("T")[0]}</th>
          <th>{new Date(element.DOD).toISOString().split("T")[0]}</th>
          <th>{element.mobile}</th>
          <th>{element.aadharCard}</th>
          <th>
            <Link to={makeUrl(clientUrls.editPatient, "id", element.id)}>
              Edit
            </Link>
            <br />
            <Link
              to={clientUrls.viewPatient}
              onClick={(e) => {
                this.deletePatient(element.id);
              }}
            >
              Delete
            </Link>
            <br />
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={makeUrl(serverUrls.getData, "id", element.id)}
            >
              Download
            </a>
          </th>
        </tr>
      );
    });

    return (
      <Container style={{ textAlign: "left" }}>
        <br />
        <Form
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              this.setState({
                page: 1,
              });
              this.getPatientsList(true, 1);
            }
          }}
        >
          <Row>
            <Col sm={10}>
              <Input
                style={{
                  width: 200,
                  display: "inline",
                  marginRight: 5,
                  maxHeight: 30,
                  boxShadow: "none",
                }}
                type="text"
                name="search"
                id="search"
                onChange={this.onChange}
                value={this.state.search}
                placeholder="search patient by name"
              />
              <Button
                onClick={(e) => {
                  this.setState({
                    page: 1,
                  });
                  this.getPatientsList(true, 1);
                }}
                color="primary"
                style={{ maxHeight: 30, marginBottom: 5 }}
                size="sm"
              >
                Search
              </Button>
            </Col>
            <Col
              style={{
                marginRight: 0,
              }}
            >
              <Button
                style={{ maxHeight: 30, marginBottom: 5 }}
                size="sm"
                color="primary"
                rel="noopener noreferrer"
                target="_blank"
                href={
                  serverUrls.getCsv +
                  "?page=" +
                  this.state.page +
                  "&search=" +
                  this.state.search
                }
              >
                Download as CSV
              </Button>
            </Col>
          </Row>
        </Form>
        <br />
        <Table style={{ fontSize: 12 }} striped responsive>
          <thead>
            <tr>
              <th>No.</th>
              <th>Name</th>
              <th>Sex</th>
              <th>Cr No</th>
              <th>Disorder</th>
              <th>Ec No</th>
              <th>DOA</th>
              <th>DOS</th>
              <th>DOD</th>
              <th>Mobile</th>
              <th>Aadhar Card</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>{tableValues}</tbody>
        </Table>
        <Pagination
          itemClass="page-item"
          linkClass="page-link"
          activePage={this.state.page}
          itemsCountPerPage={10}
          totalItemsCount={10 * this.state.totalPages}
          pageRangeDisplayed={5}
          onChange={this.handlePageChange}
        />
        <div style={{ textAlign: "center" }}>
          <hr className="my-2" />
          <p>
            Department of Endocrinology
            <br />
            Postgraduate Institute of Medical Education &amp; Research
            <br />
            Chandigarh, India - 160012
          </p>
          <p className="lead"></p>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    patients: state.patientsDetails.patients,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadPatients: (search, page) => {
      var url = serverUrls.patient + "?page=" + page + "&search=" + search;
      dispatch(getPatients({ loading: true }));
      axios
        .get(url)
        .then((res) => {
          dispatch(getPatientsSuccess({ loading: false, patients: res.data }));
        })
        .catch((err) => {
          dispatch(
            getPatientsFailure({ loading: false, errors: err.response.data })
          );
        });
    },
    // resetPatientState: () => {
    //   dispatch(resetPatientState());
    // },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPatient);
